module.exports = __webpack_public_path__ + "static/media/fds.b0b199c1.jpg";